<ta-json-root-node
  [canBeDeleted]="nested"
  [collapsed]="collapsed"
  [isLastChild]="isLastChild"
  [label]="rootName"
  [fieldType]="FieldType.Object"
  [animate]="animate"
  (clickDelete)="removeSelf.emit()"
  (clickAddChild)="toggleNewControlForm()"
  (clickToggleCollapsed)="toggleCollapsed()"
></ta-json-root-node>

<ta-json-new-child-form
  *ngIf="showNewControlForm"
  [parentType]="FieldType.Object"
  [existingKeys]="controlNames"
  (submit)="submitNewControlForm($event)"
  (cancel)="showNewControlForm = false"
>
</ta-json-new-child-form>

<div
  [formGroup]="formGroup"
  [@growInOut]="collapsed ? 'collapsed' : 'open'"
>
  <ng-container *ngFor="let controlName of controlNames; let last = last">
    <div class="ml--7 pt--2" [ngClass]="{'border--left': !last}">
      <ng-container
        [ngSwitch]="getFieldType(formGroup.get(controlName)?.value)"
      >
        <ta-json-object-editor
          *ngSwitchCase="FieldType.Object"
          [formControlName]="controlName"
          [rootName]="controlName"
          [isLastChild]="last"
          [animate]="animate"
          (removeSelf)="removeControl(controlName)"
          nested
        ></ta-json-object-editor>

        <ta-json-array-editor
          *ngSwitchCase="FieldType.Array"
          [formControlName]="controlName"
          [rootName]="controlName"
          [isLastChild]="last"
          [animate]="animate"
          (removeSelf)="removeControl(controlName)"
          nested
        ></ta-json-array-editor>

        <ta-json-value-editor
          *ngSwitchDefault
          [formControlName]="controlName"
          [key]="controlName"
          [isLastChild]="last"
          [animate]="animate"
          (delete)="removeControl(controlName)"
        ></ta-json-value-editor>
      </ng-container>
    </div>
  </ng-container>
</div>
